/** Capa padrão quando `/api/media` ou outra URL de imagem falha (ex.: API local parada). */
export const DEFAULT_EXPERIENCE_COVER_IMAGE =
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80';
